import { LEGEND_MACHINE, Legend } from './features/mcs-status-default'
import MCSMachine from './mcs-machine'

/**
 * MCS용 Unit > Transport들의 공통 속성을 정의한 오브젝트
 */
export default class MCSTransport extends MCSMachine {
  static get properties(): any {
    return MCSMachine.properties
  }

  get status() {
    return this.data?.STATUS
  }

  getLegendFallback(): Legend {
    return LEGEND_MACHINE
  }
}
